import React from 'react';
import PropTypes from 'prop-types';
import './FilterTag.scss';

function FilterTag({ options, handleChange, selected }) {
  return (
    <div className="filter-tag-container">
      {
      options.map((option) => (
        <div>
          <label
            className={`btn btn-secondary filter-tag ${option.value} ${selected === option.value
              ? 'filtertag-selected'
              : ''}`}
            htmlFor={`tag-radio-${option.value}`}
          >
            {option.title}
          </label>
          <input
            type="radio"
            className="btn-check"
            name="tag-radio"
            id={`tag-radio-${option.value}`}
            value={option.value}
            onChange={() => handleChange(option.value)}
            checked={selected === option.value}
          />
        </div>
      ))
    }
    </div>
  );
}

FilterTag.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleChange: PropTypes.func.isRequired,
  selected: PropTypes.string,
};

FilterTag.defaultProps = {
  selected: null,
};

export default FilterTag;
